import React from "react";
import { Bar } from "react-chartjs-2";
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend,
} from "chart.js";

ChartJS.register(
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend
);

const BarChart = ({
  data,
  title,
  height = 300,
  showLegend = true,
  showGrid = true,
  backgroundColor = [
    "#7352FF",
    "#FF6B6B",
    "#4ECDC4",
    "#45B7D1",
    "#96CEB4",
    "#FFEAA7",
    "#DDA0DD",
    "#98D8C8",
  ],
  borderColor = "#7352FF",
  borderWidth = 0,
  borderRadius = 4,
  borderSkipped = false,
}) => {
  const options = {
    responsive: true,
    maintainAspectRatio: false,
    plugins: {
      legend: {
        display: showLegend,
        position: "top",
        labels: {
          usePointStyle: true,
          padding: 20,
          font: {
            size: 12,
          },
          color: "#ffffff",
        },
      },
      title: {
        display: !!title,
        text: title,
        font: {
          size: 16,
          weight: "bold",
        },
        padding: {
          top: 10,
          bottom: 20,
        },
        color: "#ffffff",
      },
      tooltip: {
        mode: "index",
        intersect: false,
        backgroundColor: "rgba(0, 0, 0, 0.9)",
        titleColor: "#ffffff",
        bodyColor: "#ffffff",
        borderColor: "#7352FF",
        borderWidth: 1,
        cornerRadius: 8,
        displayColors: true,
        callbacks: {
          label: function (context) {
            let label = context.dataset.label || "";
            if (label) {
              label += ": ";
            }
            if (context.parsed.y !== null) {
              label += new Intl.NumberFormat("en-NG", {
                style: "currency",
                currency: "NGN",
              }).format(context.parsed.y);
            }
            return label;
          },
        },
      },
    },
    scales: {
      x: {
        display: true,
        grid: {
          display: showGrid,
          color: "rgba(255, 255, 255, 0.1)",
        },
        ticks: {
          font: {
            size: 11,
          },
          maxRotation: 45,
          color: "#ffffff",
        },
      },
      y: {
        display: true,
        grid: {
          display: showGrid,
          color: "rgba(255, 255, 255, 0.1)",
        },
        ticks: {
          font: {
            size: 11,
          },
          color: "#ffffff",
          callback: function (value) {
            if (value >= 1000000) {
              return "₦" + (value / 1000000).toFixed(1) + "M";
            } else if (value >= 1000) {
              return "₦" + (value / 1000).toFixed(1) + "K";
            }
            return "₦" + value.toLocaleString();
          },
        },
      },
    },
    interaction: {
      mode: "nearest",
      axis: "x",
      intersect: false,
    },
  };

  const chartData = {
    ...data,
    datasets: data.datasets.map((dataset, index) => ({
      ...dataset,
      backgroundColor: dataset.backgroundColor || backgroundColor[index % backgroundColor.length],
      borderColor: dataset.borderColor || borderColor,
      borderWidth: dataset.borderWidth || borderWidth,
      borderRadius: dataset.borderRadius || borderRadius,
      borderSkipped: dataset.borderSkipped || borderSkipped,
    })),
  };

  return (
    <div style={{ height: height }}>
      <Bar data={chartData} options={options} />
    </div>
  );
};

export default BarChart; 